import React from 'react'

import {
    useHistory
} from 'react-router-dom'

import { 
    Auth 
} from 'aws-amplify'

import { 
    ErrorText 
} from '../../Styles/BaseStyles'

import { 
    FPFormDiv,
    FPTitleDiv,
    FPPhraseDiv,
    FPTitle,
    FPPhrase,
    EmailInputField,
    EmailMeButtonDiv,
    EmailMeButton,
    LogInButtonDiv,
    LogInButton
} from '../../Styles/Components/ForgotPasswordFieldsStyles'

import { 
    useForm 
} from 'react-hook-form'

import { useDispatch } from 'react-redux'

import { fpEmailConfirmed, fpEmailError } from '../../Redux/Slices/ForgotPasswordSlice'

function ForgotPasswordFields(props){
    const { register, errors, handleSubmit } = useForm({
        validateCriteriaMode: "all",
        mode: "onChange"
    })

    let history = useHistory()

    const dispatch = useDispatch()

    async function emailMe(data){
        let email = data.email

        try{
            await Auth.forgotPassword(email)
            dispatch(fpEmailConfirmed({email: email}))
        }
        catch(error){
            switch(error.code){
                case 'UserNotFoundException':
                    dispatch(fpEmailError({errorPhrase: 'Invalid Email: Account with given email doesn\'t exist'}))
                    break
                default:
                    dispatch(fpEmailError({errorPhrase: 'Unknown error during forgot password'}))
                    break
            }
        }
    }

    function loginTransition(){
        history.push('/login')
    }

    return (
        <>
            <FPTitleDiv>
                <FPTitle>Forgot Password?</FPTitle>
            </FPTitleDiv>
            <FPPhraseDiv>
                <FPPhrase>An email will be sent with instructions on how to reset your password.</FPPhrase>
            </FPPhraseDiv>
            <FPFormDiv>
                <form>
                    <EmailInputField 
                        type="text" name="email" placeholder="email" 
                        ref={
                            register({ 
                                required: {
                                    value: true,
                                    message: 'email is required'
                                }, 
                                maxLength: {
                                    value: 320,
                                    message: 'email exceeds 320 character limit'
                                }, 
                                pattern: {
                                    value: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                                    message: 'invalid email format'
                                }
                            })
                        }
                    /><br/>
                    {errors.email && <ErrorText>*{errors.email.message}</ErrorText>}
                    <EmailMeButtonDiv>
                        <EmailMeButton onClick={handleSubmit(emailMe)}>Email Me</EmailMeButton>
                    </EmailMeButtonDiv>
                    <LogInButtonDiv>
                        <LogInButton onClick={loginTransition}>Back to Log in</LogInButton>
                    </LogInButtonDiv>
                </form>
            </FPFormDiv>
        </>
    )
}

export default ForgotPasswordFields